'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { listOf } from 'react-immutable-proptypes';
import QuotaFlag from './QuotaFlag';
import { ForecastStage, stageType } from './ForecastStage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getTotalAmount = stages => {
  return stages.reduce((sum, stage) => sum + stage.get('predictedAmount'), 0);
};
const getSizes = (stages, quota) => {
  const stagesAmount = getTotalAmount(stages);
  if (quota >= stagesAmount) {
    const stagesSize = stagesAmount / quota;
    return {
      stagesSize,
      quotaSize: 1 - stagesSize,
      quotaPosition: 1
    };
  }
  return {
    stagesSize: 1,
    quotaSize: 0,
    quotaPosition: quota / stagesAmount
  };
};
const percent = value => {
  return `${value * 100}%`;
};
const StyledBarChart = styled.div.withConfig({
  displayName: "ForecastBar__StyledBarChart",
  componentId: "vgoiql-0"
})(["position:relative;height:211px;"]);
const ForecastBar = ({
  stages,
  quota,
  currencyCode,
  onDrilldown,
  isMobile
}) => {
  const {
    stagesSize,
    quotaSize,
    quotaPosition
  } = getSizes(stages, quota);
  const quotaFlag = quota != null && !isMobile ? /*#__PURE__*/_jsx(QuotaFlag, {
    style: {
      right: percent(1 - quotaPosition)
    },
    quota: quota,
    reversed: quotaPosition < 0.8,
    currencyCode: currencyCode
  }) : null;
  const StyledForecastBar = isMobile ? styled(TFlex).withConfig({
    displayName: "ForecastBar__StyledForecastBar",
    componentId: "vgoiql-1"
  })(["z-index:2;position:absolute;left:0;"]) : styled(TFlex).withConfig({
    displayName: "ForecastBar__StyledForecastBar",
    componentId: "vgoiql-2"
  })(["z-index:2;position:absolute;bottom:0;left:0;"]);
  return /*#__PURE__*/_jsx(StyledBarChart, {
    children: /*#__PURE__*/_jsxs(StyledForecastBar, {
      align: "stretch",
      "data-test-id": "dealForecast-bar",
      children: [stages.map((stage, i) => {
        return /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(TFlex, {
            borderRadius: 200,
            flexBasis: 0,
            flexGrow: stage.get('percent') * stagesSize,
            flexDirection: "column",
            alignItems: "stretch",
            paddingInlineEnd: 50,
            children: /*#__PURE__*/_jsx(ForecastStage, {
              stage: stage,
              stageId: stage.get('stage'),
              onDrilldown: name => onDrilldown(stage.get('stage'), name),
              currencyCode: currencyCode,
              showLabels: stage.get('percent') * stagesSize > 0.1,
              isMobile: isMobile,
              first: i === 0,
              last: i === stages.length - 1
            })
          }, stage.get('stage'))
        });
      }), /*#__PURE__*/_jsx(Box, {
        marginBlockStart: 900,
        marginBlockEnd: 600,
        blockSize: 75,
        backgroundColor: 'do-not-use-cirrus',
        grow: quotaSize,
        children: quotaFlag
      })]
    })
  });
};
ForecastBar.propTypes = {
  stages: listOf(stageType),
  quota: PropTypes.number,
  currencyCode: PropTypes.string.isRequired,
  onDrilldown: PropTypes.func.isRequired,
  isMobile: PropTypes.bool
};
export default ForecastBar;